module.exports = __webpack_public_path__ + "img/mcl-square.d5643c11.png";